
























import { Component, Vue, Prop } from 'vue-property-decorator';
import { GQL_currentUnitProductGroups_currentUnit_productGroups } from '@/queries/__generated__/currentUnitProductGroups';
import gql from 'graphql-tag';

const DELETE_PRODUCT_GROUP = gql`
  mutation deleteProductGroup($id: ID!) {
    deleteProductGroup(
      input: {
        id: $id,
      }
    ) {
      productGroup {
        id
      }
    }
  }
`;


@Component
export default class ProductGroupDeleteButton extends Vue {
  @Prop() private productGroup!: GQL_currentUnitProductGroups_currentUnit_productGroups;
  private DELETE_PRODUCT_GROUP = DELETE_PRODUCT_GROUP;

  private confirmDelete(confirmMutation: () => {}) {
    this.$sPopup.confirm('', {
      title: this.$t('PopupTitle.confirmDelete'),
      message: this.$t('PopupBody.confirmDelete', { thing: this.productGroup.name }),
      onConfirm: confirmMutation,
    });
  }
}
